import React from "react";
import { Chip, Box, BoxProps, styled } from "@material-ui/core";

const ErrorChip = styled(Chip)(({ theme }) => ({
  borderColor: theme.palette.error.main,
}));

const WarningChip = styled(Chip)(({ theme }) => ({
  borderColor: theme.palette.warning.main,
}));

const InfoChip = styled(Chip)(({ theme }) => ({
  borderColor: theme.palette.secondary.main,
}));

const SuccessChip = styled(Chip)(({ theme }) => ({
  borderColor: theme.palette.success.main,
}));

const NormalChip = styled(Chip)(({ theme }) => ({
  borderColor: theme.palette.text.secondary,
}));

interface Props extends BoxProps {
  type?: "Error" | "Warning" | "Info" | "Success";
  label: string;
}

export const ColorChip: React.FC<Props> = ({ type, label, ...props }) => (
  <Box {...props}>
    {type === "Error" ? (
      <ErrorChip
        size="small"
        variant="outlined"
        label={label}
        data-testid="ErrorChip"
      />
    ) : type === "Warning" ? (
      <WarningChip
        size="small"
        variant="outlined"
        label={label}
        data-testid="WarningChip"
      />
    ) : type === "Info" ? (
      <InfoChip
        size="small"
        variant="outlined"
        label={label}
        data-testid="InfoChip"
      />
    ) : type === "Success" ? (
      <SuccessChip
        size="small"
        variant="outlined"
        label={label}
        data-testid="SuccessChip"
      />
    ) : (
      <NormalChip
        size="small"
        variant="outlined"
        label={label}
        data-testid="NormalChip"
      />
    )}
  </Box>
);
